import { ITableConfig, ITableRowConfig } from 'components/Table/types';

const rowConfigs: ITableRowConfig[] = [
  {
    header: 'Supplier Order No',
    flexValue: 1,
    alternativeSortField: 'internal_number',
  },
  { header: 'Logyx Order ID', flexValue: 1, alternativeSortField: 'number' },
  {
    header: 'Buyer Name',
    flexValue: 1,
    alternativeSortField: 'company_name',
  },
  { header: 'Status', flexValue: 1 },
  { header: 'Delivery Date', flexValue: 1 },
  {
    header: 'Supplier Reference',
    flexValue: 1,
    alternativeSortField: 'reference',
  },
  { header: 'Creation Date', flexValue: 1, alternativeSortField: 'created_at' },
  // { header: 'Connected Quotation', flexValue: 1 },
];

export const tableConfig: ITableConfig = {
  rowConfigs: rowConfigs,
  extraActionsFlexValue: 0.5,
};

export const ORDERS_PER_PAGE = 10;
